import { extendMembership } from "../../../../Redux/Members/MembersActions";
import { updateProfile } from "../../../../Redux/Profile/ProfileActions";
import { AppDispatch, RootState } from "../../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import validator from "../../../../Util/validator";
import React, { useEffect, useState } from "react";
import styles from "./MyProfile.module.scss";
import moment from "moment";
import { useNavigate } from "react-router";

function MyProfile() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { profileByIdData, updateProfileLoading } = useSelector(
    (state: RootState) => state.profile,
  );
  const { extendMembershipLoading } = useSelector(
    (state: RootState) => state.members,
  );
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [nationalIdCard, setNationalIdCard] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [errors, setErrors] = useState<{
    name: string;
    email: string;
    nationalIdCard: string;
    phoneNumber: string;
  }>({
    name: "",
    email: "",
    nationalIdCard: "",
    phoneNumber: "",
  });
  const updateProfileHandler = () => {
    if (!updateProfileLoading) {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "name",
          type: "text",
          value: name,
        },
        {
          key: "nationalIdCard",
          type: "text",
          value: nationalIdCard,
        },
        {
          key: "phoneNumber",
          type: "text",
          value: phoneNumber,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid) {
        dispatch(
          updateProfile({
            firstName: name.split(" ")[0],
            lastName: name.split(" ")[1],
            email: email,
            idNumber: nationalIdCard,
            phonenumber: phoneNumber,
            navigate: navigate,
          }),
        );
      }
    }
  };

  useEffect(() => {
    if (profileByIdData) {
      setName(
        `${profileByIdData?.member?.firstName} ${profileByIdData?.member?.lastName}`,
      );
      setEmail(profileByIdData?.member?.email);
      setNationalIdCard(profileByIdData?.member?.nationalId);
      setPhoneNumber(profileByIdData?.member?.phonenumber);
    }
  }, [profileByIdData]);

  const downloadLastContractHandler = () => {
    if (profileByIdData) {
      window.open(profileByIdData?.lastContract?.documentPath, "_blank");
    }
  };

  const extendMembershipHandler = () => {
    if (!extendMembershipLoading) {
      dispatch(
        extendMembership({
          memberId: profileByIdData?.member?.memberId,
        }),
      );
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContainerBox}>
        <div className={styles.headingContainer}>
          <p className={styles.heading}>Profile Information</p>
          {profileByIdData?.packages &&
            moment(profileByIdData?.packages?.packageSubExpire).isBefore(
              moment(),
            ) && (
              <div className={styles.buttonContainer}>
                <button
                  className={styles.button}
                  onClick={extendMembershipHandler}
                >
                  Extend membership
                </button>
              </div>
            )}
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.input}>
            <p className={styles.label}>Email</p>
            <input
              type="text"
              className={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              readOnly
            />
            <p className={styles.error}>{errors.email}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.input}>
            <p className={styles.label}>Name</p>
            <input
              type="text"
              className={styles.input}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <p className={styles.error}>{errors.name}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.input}>
            <p className={styles.label}>National ID Card</p>
            <input
              type="text"
              className={styles.input}
              value={nationalIdCard}
              onChange={(e) => setNationalIdCard(e.target.value)}
            />
            <p className={styles.error}>{errors.nationalIdCard}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.input}>
            <p className={styles.label}>Phone Number</p>
            <input
              type="text"
              className={styles.input}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <p className={styles.error}>{errors.phoneNumber}</p>
          </div>
        </div>
        {updateProfileLoading && <Loading />}
        <div className={styles.profileButtonContainer}>
          <div className={styles.buttonContainer}>
            <button className={styles.button} onClick={updateProfileHandler}>
              Update
            </button>
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={styles.button}
              onClick={downloadLastContractHandler}
            >
              Download Last Contract
            </button>
          </div>
          {extendMembershipLoading && <Loading />}
        </div>
      </div>
    </div>
  );
}

export default MyProfile;
